export default __webpack_public_path__ + "static/banner-048ecfba61144aaa113bcf17db8b0f58.png";